import React, { useContext, useState, useEffect } from "react";
import { Switch, Route, Redirect, useRouteMatch } from "react-router-dom";

import Dashboard from "area/cui/Dashboard"
import Appearance from "components/Pages/Appearance"
import ContractMangement from "area/cui/ContractMangement"
import ComplianceMangement from "area/cui/ComplianceMangement"
import Accounting from "area/cui/Accounting"
import EmailTemplate from "area/cui/EmailTemplate"
import LogiqMindManager from "components/Pages/LogiqMindManager"
import Uploads from "area/cui/Uploads";
import Layout from "./Layout"

export default function CUIRoutes() {
    let { path, url } = useRouteMatch();

    useEffect(() => {
        document.title = "AXIM FringeSecure | Prime Contract Partner";
    },[])

    return (
      <Layout>
        <Switch>
            <Route exact path={`${path}/`}>
                <Redirect to={`${path}/dashboard`} />
            </Route>
            <Route exact path={`${path}/dashboard`} component={Dashboard} />
            <Route exact path={`${path}/appearance`} component={Appearance} />
            <Route exact path={`${path}/logiqmind-manager`} component={LogiqMindManager} />
            <Route exact path={`${path}/contracts`} component={ContractMangement} />
            <Route exact path={`${path}/accounting`} component={Accounting} />
            <Route exact path={`${path}/compliance`} component={ComplianceMangement} />
            <Route exact path={`${path}/template`} component={EmailTemplate} />
            <Route exact path={`${path}/uploads`} component={Uploads} />
            
        </Switch>
      </Layout>
    )
}